/**
 * Platform Detection Utilities
 * Detects whether the app is running in a browser, PWA, or native Capacitor app
 */

import { Capacitor } from '@capacitor/core';

/**
 * Check if running as a native Android app (via Capacitor)
 */
export function isNativeAndroid() {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
}

/**
 * Check if running as a native iOS app (via Capacitor)
 */
export function isNativeIOS() {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
}

/**
 * Check if running as a native app (Android or iOS)
 */
export function isNativeApp() {
  return Capacitor.isNativePlatform();
}

/**
 * Check if running in a web browser (not native)
 */
export function isWeb() {
  return !Capacitor.isNativePlatform();
}

/**
 * Get the current platform name
 * @returns {'android' | 'ios' | 'web'}
 */
export function getPlatform() {
  return Capacitor.getPlatform();
}

/**
 * Check if running as an installed PWA
 */
export function isPWA() {
  return (
    isWeb() &&
    (window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true)
  );
}

/**
 * Determine the appropriate push notification method
 * @returns {'fcm' | 'web' | 'none'}
 */
export function getPushMethod() {
  if (isNativeAndroid()) {
    return 'fcm';
  }
  if (isWeb() && 'serviceWorker' in navigator && 'PushManager' in window) {
    return 'web';
  }
  return 'none';
}

export default {
  isNativeAndroid,
  isNativeIOS,
  isNativeApp,
  isWeb,
  getPlatform,
  isPWA,
  getPushMethod,
};
